export const PHONE_DISPLAY = "+91 96118 29277";
export const PHONE_TEL = "tel:+919611829277";
export const WHATSAPP_LINK = (msg) =>
  `https://wa.me/919611829277?text=${encodeURIComponent(msg)}`;
export const WA_DEFAULT = WHATSAPP_LINK(
  "Hello Hotel Anil Palace! I would like to enquire about room availability and tariff for my upcoming stay."
);
export const MAPS_DIRECTIONS =
  "https://maps.google.com/?q=Hotel+Anil+Palace+Hemmadi+Karnataka+576230";
export const MAPS_EMBED =
  "https://maps.google.com/maps?q=Hotel%20Anil%20Palace%2C%20Hemmadi%2C%20Karnataka%20576230&t=&z=14&ie=UTF8&iwloc=&output=embed";
export const ADDRESS =
  "NH66, Opposite Janata College, Hemmadi, Karnataka 576230";

export const PHOTOS = {
  building:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_1adcd13e-3b9b-4d18-8ec7-bb7473ae9fd4/artifacts/e4674efa77f80bcd_building.jpeg",
  reception:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_1adcd13e-3b9b-4d18-8ec7-bb7473ae9fd4/artifacts/1d22d6d15054bd78_reception.jpeg",
  entry:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_1adcd13e-3b9b-4d18-8ec7-bb7473ae9fd4/artifacts/06bf11a3f7742453_front%20entry.jpeg",
  room1:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_1adcd13e-3b9b-4d18-8ec7-bb7473ae9fd4/artifacts/ac7b72a71082f198_room%201.jpeg",
  room2:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_1adcd13e-3b9b-4d18-8ec7-bb7473ae9fd4/artifacts/2db87d142bb951db_room2.jpeg",
};

export const ROOM_TABS = [
  {
    id: "deluxe",
    testid: "room-category-tab-deluxe",
    label: "Deluxe Rooms",
    kannada: "ಡಿಲಕ್ಸ್ ಕೋಣೆಗಳು",
    blurb:
      "Warm wood-panelled AC rooms with plush king beds, ambient ceiling coves and attached bath — built for deep rest after the coastal road.",
    features: ["Air Conditioning", "King Bed", "LED TV", "Attached Bath", "Free Wi-Fi", "Hot Water"],
    images: [
      { src: PHOTOS.room1, caption: "Deluxe AC Room — king bed & cove lighting" },
      { src: PHOTOS.room2, caption: "Deluxe AC Room — wood-panelled headboard" },
    ],
  },
  {
    id: "family",
    testid: "room-category-tab-family",
    label: "Family Stays",
    kannada: "ಕೌಟುಂಬಿಕ ವಸತಿ",
    blurb:
      "Spacious layouts for families and pilgrimage groups travelling together to Mookambika — extra bedding on request, 24×7 check-in.",
    features: ["Sleeps 3–4", "Extra Bedding", "24×7 Check-in", "Room Service", "Laundry & Iron", "Travel Desk"],
    images: [
      { src: PHOTOS.room2, caption: "Family stay — generous floor space" },
      { src: PHOTOS.room1, caption: "Family stay — cool, quiet interiors" },
    ],
  },
  {
    id: "property",
    testid: "room-category-tab-property",
    label: "The Property",
    kannada: "ನಮ್ಮ ಹೋಟೆಲ್",
    blurb:
      "A landmark glass facade on NH66 with its own parking forecourt, marble reception and lift access to every floor.",
    features: ["On-site Parking", "Lift Access", "Marble Reception", "CCTV Security", "Power Backup", "NH66 Frontage"],
    images: [
      { src: PHOTOS.building, caption: "The facade on NH66, Hemmadi" },
      { src: PHOTOS.reception, caption: "Reception & front desk, staffed 24×7" },
      { src: PHOTOS.entry, caption: "Entrance — ಅನಿಲ್ ಪ್ಯಾಲೇಸ್" },
    ],
  },
];

export const ATTRACTIONS = [
  {
    id: "kollur-mookambika",
    testid: "attraction-card-kollur-mookambika",
    name: "Kollur Sri Mookambika Temple",
    kannada: "ಕೊಲ್ಲೂರು ಮೂಕಾಂಬಿಕೆ",
    distance: "~40 km",
    time: "1 hr drive",
    span: "wide",
    image:
      "https://images.unsplash.com/photo-1665003815164-8f5bc853ef44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjB0ZW1wbGUlMjBoZXJpdGFnZXxlbnwwfHx8fDE3OTE2OTgxMTR8MA&ixlib=rb-4.1.0&q=85",
    text: "One of South India's most revered Shakti shrines, cradled by the Kodachadri hills on the Souparnika river. We arrange early-morning darshan taxis.",
  },
  {
    id: "maranakatte",
    testid: "attraction-card-maranakatte",
    name: "Maranakatte Brahmalingeshwara",
    kannada: "ಮಾರನಕಟ್ಟೆ",
    distance: "~14 km",
    time: "20 min drive",
    span: "tall",
    image:
      "https://images.unsplash.com/photo-1557062975-96113e46608b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB0ZW1wbGUlMjBoZXJpdGFnZXxlbnwwfHx8fDE3OTE2OTgxMTR8MA&ixlib=rb-4.1.0&q=85",
    text: "Ancient riverside shrine wrapped in evergreen groves — where legend says Goddess Mookambika vanquished Mookasura.",
  },
  {
    id: "maravante-beach",
    testid: "attraction-card-maravante-beach",
    name: "Maravante Beach",
    kannada: "ಮಾರವಂತೆ ಬೀಚ್",
    distance: "~8 km",
    time: "12 min drive",
    span: "wide",
    image:
      "https://images.unsplash.com/photo-1571043281665-9debfed10719?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHx0cm9waWNhbCUyMGJlYWNoJTIwc3Vuc2V0JTIwcGFsbXxlbnwwfHx8fDE3OTE2OTgxMTR8MA&ixlib=rb-4.1.0&q=85",
    text: "The famous NH66 stretch where the highway runs between the Arabian Sea and the Souparnika river. Stay for the sunset.",
  },
  {
    id: "ottinene",
    testid: "attraction-card-ottinene",
    name: "Ottinene Viewpoint",
    kannada: "ಒಟ್ಟಿನೆಣೆ",
    distance: "~18 km",
    time: "25 min drive",
    span: "std",
    image:
      "https://images.unsplash.com/photo-1561571994-3c61c554181a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGJlYWNoJTIwc3Vuc2V0JTIwcGFsbXxlbnwwfHx8fDE3OTE2OTgxMTR8MA&ixlib=rb-4.1.0&q=85",
    text: "Cliff-edge views over the Byndoor estuary — palms, river and sea in one frame.",
  },
  {
    id: "murudeshwar",
    testid: "attraction-card-murudeshwar",
    name: "Murudeshwar Temple & Beach",
    kannada: "ಮುರುಡೇಶ್ವರ",
    distance: "~48 km",
    time: "1 hr drive",
    span: "std",
    image:
      "https://images.unsplash.com/photo-1566915682737-3e97a7eed93b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB0ZW1wbGUlMjBoZXJpdGFnZXxlbnwwfHx8fDE3OTE2OTgxMTR8MA&ixlib=rb-4.1.0&q=85",
    text: "The towering Shiva statue and 20-storey Raja Gopura rising over the sea, with boat rides to Netrani island.",
  },
];
